// @ts-nocheck
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import hydrateStyledCss from "@store/Framework/Common/Utilities/hydrateStyledCss";
import { css, ThemedCssFunction } from "styled-components";

const polyfillCss: ThemedCssFunction<BaseTheme> = (first: any, ...interpolations: any): any => css`
    ${x => hydrateStyledCss(css(first, ...interpolations), x)}
`;

export default polyfillCss;
